// src/reducers/listActions.js
export const ACTIONS = {
    FETCH_INIT: 'FETCH_INIT',
    FETCH_SUCCESS: 'FETCH_SUCCESS',
    FETCH_FAILURE: 'FETCH_FAILURE',
    SET_ORDER: 'SET_ORDER',
    SET_ORDER_BY: 'SET_ORDER_BY',
    SET_PAGE: 'SET_PAGE',
    SET_ROWS_PER_PAGE: 'SET_ROWS_PER_PAGE',
    UPDATE_COMMENTS: 'UPDATE_COMMENTS',
  };  